const styles = (theme) => ({
  youAreLabel: {
    color: theme.colors.themeDarkerGray,
    textAlign: 'left',
  },
});

export default styles;
